// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"848d16fc","839":"ec06f21b"}[chunkId] + ".chunk.css";
};